import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ToastrModule } from 'ngx-toastr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Select2Module } from 'ng-select2-component';
import es from '@angular/common/locales/es';
import de from '@angular/common/locales/de';


import { registerLocaleData } from '@angular/common';

registerLocaleData(es);
registerLocaleData(de);

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DefaultLayoutComponent } from './containers/default-layout/default-layout.component';
import { Helpers } from './helpers/helpers';
import { AuthInterceptorService } from './services/auth-interceptor.service';
import { CallbackComponent } from './components/callback/callback.component';
import { CustomValidators } from './helpers/custom-validators';
import { SharedModule } from './components/shared/shared.module';
import { LocalCampaignViewerComponent } from './components/public/local-campaign-viewer/local-campaign-viewer.component';
import { AuthConfigModule } from './auth/auth-config.module';
import { AbstractSecurityStorage } from 'angular-auth-oidc-client';
import { LocalStorageSecurityStorage } from './auth/local-storage.service';
import { ConditionsAcceptComponent } from './components/conditions-accept/conditions-accept.component';
import { CheckUserR1Component } from './components/check-user-R1/check-user-R1.component';
import { LoginJwtComponent } from './components/login-jwt/login-jwt.component';
import { AuthJwtInterceptorService } from './services/auth-jwt-interceptor.service';
import { CampaignCrmViewerComponent } from './components/public/campaign-crm-viewer/campaign-crm-viewer.component';
import { RenaultAnimationHomeComponent } from './components/renault-zone/animation-home/animation-home.component';
import { FileValidationService } from './services/file-interceptor';
import { PapLocalCampaignViewerComponent } from './components/public/pap-local-campaign-viewer/pap-local-campaign-viewer.component';
import { CheckUserR2OkComponent } from './components/check-user-R2-ok/check-user-R2-ok.component';
import { LeadApprovedComponent } from './components/public/lead-approved/lead-approved.component';

const APP_CONTAINERS = [
  DefaultLayoutComponent
];

@NgModule({
  declarations: [
    AppComponent,
    ConditionsAcceptComponent,
    CheckUserR1Component,
    CheckUserR2OkComponent,
    CallbackComponent,
    RenaultAnimationHomeComponent,
    LocalCampaignViewerComponent,
    PapLocalCampaignViewerComponent,
    CampaignCrmViewerComponent,
    LeadApprovedComponent,
    LoginJwtComponent,
    ...APP_CONTAINERS
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    RouterModule,
    ToastrModule.forRoot(),
    NgbModule,
    SharedModule,
    AuthConfigModule,
    Select2Module
  ],
  providers: [
    Helpers,
    CustomValidators,
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy
    },
    { provide: LOCALE_ID, useValue: 'es-ES' },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthJwtInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: FileValidationService, multi: true },
    { provide: AbstractSecurityStorage, useClass: LocalStorageSecurityStorage }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
